import { frontendURL } from '../../../helper/URLHelper';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';
import Index from './Index.vue';

const routerGuard = async (to, from, next) => {
  await subscriptionGuard(to, from, next, store);
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      component: Index,
      name: 'onboarding',
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: routerGuard,
    },
  ],
};
